module.exports = __webpack_public_path__ + "img/ring_skip_skip_1_1.f662df7e.png";